import React, {useState} from "react"
import Box from "@mui/material/Box"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import Typography from "@mui/material/Typography"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import MealDataFetcher from "./MealDataFetcher" // Import your MealDataFetcher
import {useLanguage} from "../context/LanguageContext"

export default function Toggle({items, onSubCategoryClick}) {
  const {languageId} = useLanguage()
  const [expanded, setExpanded] = useState(null)
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState(null)

  const getLocalizedSubcategory = (subcategory) => {
    if (
      !subcategory.subcategorylang ||
      subcategory.subcategorylang.length === 0
    ) {
      console.warn("subcategorylang is missing or empty for:", subcategory)
      return {name: subcategory.name || "Unnamed", description: ""}
    }

    const languageIdNum = Number(languageId)
    const localized = subcategory.subcategorylang.find(
      (lang) => lang.language === languageIdNum
    )

    return {
      name: localized ? localized.name : subcategory.name,
      description: localized ? localized.description : "",
    }
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const handleSubCategoryClick = (id) => {
    if (selectedSubCategoryId !== id) {
      setSelectedSubCategoryId(id)
      if (onSubCategoryClick) {
        onSubCategoryClick(id)
      }
    }
  }

  return (
    <Box sx={{minHeight: 352, minWidth: 250}}>
      {items.map((subSection) => {
        const {name: localizedName, description: localizedDescription} =
          getLocalizedSubcategory(subSection)

        if (!localizedName) return null

        const isExpanded = expanded === `subSection-${subSection.id}`

        return (
          <Accordion
            key={subSection.id}
            expanded={isExpanded}
            onChange={handleChange(`subSection-${subSection.id}`)}
            sx={{
              bgcolor: "black",
              color: "white",
              boxShadow: "0px 4px 12px rgba(96, 92, 9, 0.5)",
              marginBottom: 2,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{color: "white"}} />}
              aria-controls={`subSection-${subSection.id}-content`}
              id={`subSection-${subSection.id}-header`}
              onClick={() => handleSubCategoryClick(subSection.id)}
            >
              <Typography variant="h6">{localizedName}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" mb={2}>
                {localizedDescription}
              </Typography>
              {isExpanded && (
                <MealDataFetcher subCategoryId={subSection.id} />
              )}
            </AccordionDetails>
          </Accordion>
        )
      })}
    </Box>
  )
}
